import React, { useState, useEffect } from 'react';
import adminService from '../../services/adminService';
import commonStyles from '../AdminOrdersPage/AdminOrdersPage.module.scss'; // Tái sử dụng CSS bảng
import { toast } from 'react-toastify';
import { Iopencil, IoRefresh } from 'react-icons/io5';

const AdminInventoryPage = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadInventory();
  }, []);

  const loadInventory = () => {
    setLoading(true);
    adminService.getAdminProducts()
      .then(res => {
        setProducts(res.data.records || []);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  };

  // Hàm xử lý cập nhật nhanh
  const handleQuickUpdate = (product) => {
    const newQty = prompt(`Nhập số lượng tồn kho mới cho "${product.name}":`, product.stock_quantity);
    
    if (newQty !== null) {
      const qtyNumber = parseInt(newQty);
      if (isNaN(qtyNumber) || qtyNumber < 0) {
        toast.error("Vui lòng nhập số hợp lệ!");
        return;
      }

      adminService.updateStockQuick(product.id, qtyNumber)
        .then(() => {
          toast.success("Đã cập nhật kho!");
          // Cập nhật giao diện ngay lập tức
          setProducts(prev => prev.map(p => 
            p.id === product.id ? { ...p, stock_quantity: qtyNumber } : p
          ));
        })
        .catch(err => toast.error("Lỗi: " + err.response.data.message));
    }
  };

  return (
    <div className={commonStyles.adminPage}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h1>Quản Lý Kho Hàng</h1>
        <button onClick={loadInventory} className={commonStyles.actionButton}><IoRefresh /> Làm mới</button>
      </div>
      
      {loading ? <p>Đang tải...</p> : (
        <table className={commonStyles.adminTable}>
          <thead>
            <tr>
              <th>Tên Sản Phẩm</th>
              <th>Giá Bán</th>
              <th>Đã Bán</th>
              <th>Tồn Kho</th>
              <th>Trạng Thái</th>
              <th>Hành Động</th>
            </tr>
          </thead>
          <tbody>
            {products.map(p => (
              <tr key={p.id}>
                <td data-label="Tên Sản Phẩm" style={{ fontWeight: '500' }}>{p.name}</td>
                <td data-label="Giá Bán">{new Intl.NumberFormat('vi-VN').format(p.price)} đ</td>
                <td data-label="Đã Bán" style={{ color: '#666' }}>{p.sales_count || 0}</td>
                <td data-label="Tồn Kho" style={{ 
                    fontWeight: 'bold', 
                    color: p.stock_quantity <= 5 ? '#d32f2f' : '#388e3c',
                    fontSize: '1.1rem'
                }}>
                  {p.stock_quantity}
                </td>
                
                <td data-label="Trạng Thái">
                   {p.stock_quantity > 0 
                     ? <span style={{ color: 'green', background: '#e8f5e9', padding: '4px 8px', borderRadius: '4px', fontSize: '0.85rem' }}>Còn hàng</span>
                     : <span style={{ color: 'red', background: '#ffebee', padding: '4px 8px', borderRadius: '4px', fontSize: '0.85rem' }}>Hết hàng</span>
                   }
                </td>
                
                <td data-label="Hành Động">
                  <button 
                    className={commonStyles.actionButton} 
                    onClick={() => handleQuickUpdate(p)}
                  >
                     Cập nhật
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminInventoryPage;